export default __webpack_public_path__ + "static/media/IBMPlexSans-ThinItalic.fe3aa856.woff";